const Description = ({ description }) => {
    return (
        <div className="my-4 bg-white p-4 rounded-4">
            <h5 className="mb-3">About This Trip</h5>
            <p>{description}</p>
        </div>
    )
}

export default Description;